module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/f430aadbdeb34a2c9dc015d6778c7b1f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_filter.svg
// module id = vMm+
// module chunks = 0